import VehiclePickerController from './vehicle_picker_controller';

export const controllers = [
  { id: 'vehicle-picker', controller: VehiclePickerController }
];
